import React, { Component } from "react";
import { connect } from "react-redux";

import { withRouter } from "react-router";
import ProductHeader from "../ProductDetails/ProductHeader";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import { Button, CircularProgress, Divider } from "@material-ui/core";
import instance from "../../store/actions/instance";
import moment from "moment";
import { ReactComponent as LoyaltyPointsIcon } from "./assets/loyaltypoints.svg";
import { ReactComponent as Empty } from "../PastOrders/assets/empty.svg";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";

class Wallet extends Component {
  state = {
    history: [],
    historyLoading: false,
  };
  componentDidMount = async () => {
    try {
      this.setState({ historyLoading: true });
      const res = await instance.get("get_points_history/");

      this.setState({ history: res.data });
    } catch (err) {}
    this.setState({ historyLoading: false });
  };

  render() {
    const { auth, language, settings } = this.props;
    const { history, historyLoading } = this.state;
    if (
      !auth.user ||
      !settings.enable_loyalty_points ||
      !settings.enable_loyalty_points_staff
    ) {
      this.props.history.replace("/profile");
    }
    const loyaltyPointsNeeded =
      (
        (auth.user?.points * settings.loyalty_points_to_money_conversion_rate) /
        settings.loyalty_points_to_money_threshold
      ).toFixed(settings.currency_decimals) || "-";
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <div
        className="text-center"
        style={{ backgroundColor: "white", minHeight: "100vh" }}
      >
        <ProductHeader onBack={() => this.props.history.replace("/profile")} />
        <div className="free-space-70-white"></div>
        <div
          style={{
            display: "flex",
            flexDirection: language === "arabic" && "row-reverse",
            alignItems: "baseline",
            justifyContent: "space-between",
          }}
          className="mx-3"
        >
          <h2 classname="bold" style={{ fontSize: 18, color: "#666666" }}>
            {language == "english"
              ? settings.custom_texts.loyalty_points_text
              : settings.custom_texts.loyalty_points_text_ar}
          </h2>
        </div>
        <div
          style={{
            display: "flex",
            gap: 30,
            flexDirection: language === "arabic" && "row-reverse",
          }}
          className="mx-4 mt-4"
        >
          <LoyaltyPointsIcon style={{ height: 50, width: 50 }} />
          <div
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: language === "arabic" && "row-reverse",
            }}
          >
            <div
              style={{
                textAlign: (language === "arabic" && "right") || "left",
              }}
            >
              <p
                className="mb-1 bold"
                style={{ fontSize: 14, color: "#666666" }}
              >
                {language == "english" ? "Total earned" : "النقاط الإجماليه"}
              </p>
              <p
                className="mb-1 bold"
                style={{ fontSize: 14, color: "#666666" }}
              >
                {language == "english" ? "Balance" : "الرصيد"}
              </p>
            </div>
            <div
              style={{
                textAlign: (language === "arabic" && "right") || "left",
              }}
            >
              <p
                className="mb-1 bold"
                style={{ fontSize: 14, color: "#666666" }}
              >
                {auth.user?.total_points}
              </p>
              <p
                className="mb-1 bold"
                style={{ fontSize: 14, color: "#666666" }}
              >
                {settings.enable_loyalty_points_payment ? (
                  <>
                    {`${auth.user?.points} = `}
                    {settings.currency_iso === "SAR" && (
                      <span
                        className={`${
                          currencyIcon
                        } `}
                      ></span>
                    )}
                    {loyaltyPointsNeeded}{" "}
                    {settings.currency_iso !== "SAR" &&
                      `${
                        language == "arabic"
                          ? settings.currency_local
                          : settings.currency_iso
                      }`}
                  </>
                ) : (
                  auth.user?.points
                )}
              </p>
            </div>
          </div>
        </div>
        <Divider className="mt-4" />

        <div
          style={{
            display: "flex",
            flexDirection: language === "arabic" && "row-reverse",
            alignItems: "baseline",
            justifyContent: "space-between",
          }}
          className="mx-3 mt-4"
        >
          <h2 classname="bold" style={{ fontSize: 18, color: "#666666" }}>
            {language == "english" ? "History" : "السجل"}
          </h2>
        </div>

        {history.length > 0 && (
          <>
            <div
              className="mx-4 mt-4"
              style={{
                display: "flex",
                flexDirection: language === "arabic" && "row-reverse",
                justifyContent: "space-between",
              }}
            >
              <span
                className="bold"
                style={{
                  color: "#666666",
                  flex: 1,
                  textAlign: (language === "arabic" && "right") || "left",
                }}
              >
                {language === "english" ? "Created" : "تاريخ الإنشاء"}
              </span>
              <span className="bold" style={{ color: "#666666", flex: 2 }}>
                {language === "english" ? "Order ID" : "رمز الطلب"}
              </span>
              <span
                className="bold"
                style={{
                  color: "#666666",
                  flex: 1,
                  textAlign: (language === "arabic" && "right") || "left",
                }}
              >
                {language === "english" ? "Expiry" : "تاريخ الانتهاء"}
              </span>
              <span className="bold" style={{ color: "#666666", flex: 2 }}>
                {language === "english" ? "Earned/Spent" : "كسبت/صرفت"}
              </span>
              <span
                className="bold"
                style={{
                  flex: 1,
                  color: "#666666",
                  textAlign: (language === "arabic" && "left") || "right",
                }}
              >
                {language === "english" ? "Points" : "النقاط"}
              </span>
            </div>
            <hr
              className="mx-4 mt-1"
              style={{ border: "1px solid #ccc", margin: "10px 0" }}
            />
          </>
        )}

        <div class="mx-4 mt-1">
          {historyLoading ? (
            <CircularProgress color="primary" style={{ marginTop: 20 }} />
          ) : history.length <= 0 ? (
            <>
              <Empty width="100" height="100" className="mt-5" />
              <p className="mt-3">
                {language == "english"
                  ? "You don't have history"
                  : "لا يوجد سجل"}
              </p>
            </>
          ) : (
            history.map((order) => (
              <div
                style={{
                  display: "flex",
                  flexDirection: language === "arabic" && "row-reverse",
                  justifyContent: "space-between",
                }}
              >
                <p
                  className="bold"
                  style={{
                    color: "#666666",
                    flex: 1,
                    textAlign: (language === "arabic" && "right") || "left",
                  }}
                >
                  {moment(order.created).format("DD-MM-YYYY")}
                </p>
                <p
                  className="bold"
                  style={{
                    color: "#666666",
                    flex: 1,
                    textAlign: (language === "arabic" && "right") || "left",
                  }}
                >
                  {order.order_tracking_id || "-"}
                </p>
                <p
                  className="bold"
                  style={{
                    color:
                      order.expiry_date && order.is_expired !== null
                        ? !order.is_expired
                          ? "#168C13"
                          : "#D30707"
                        : "#666666",
                    flex: 1,
                    textAlign: (language === "arabic" && "right") || "left",
                  }}
                >
                  {order.expiry_date
                    ? moment(order.expiry_date).format("DD-MM-YYYY")
                    : "-"}
                </p>
                <p className="bold" style={{ color: "#666666", flex: 2 }}>
                  {`${
                    order.type == 1
                      ? (language === "arabic" && "كسبت نقاط") ||
                        "Earned Points"
                      : (language === "arabic" && "صرفت نقاط") || `Spent Points`
                  }`}
                </p>
                <p
                  className="bold"
                  style={{
                    color: order.type == 1 ? "#168C13" : "#D30707",
                    flex: 1,
                    textAlign: (language === "arabic" && "left") || "right",
                  }}
                >
                  {`${order.type == 1 ? "+" : "-"} ${order.amount}`}
                </p>
              </div>
            ))
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    auth: state.auth,
    settings: state.store.store.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Wallet));
